import { PizarraEvento } from 'src/common/pizarraEvento';
import { Action } from '@ngrx/store';
import { ContenidoStatus } from 'src/common/contenido';

export enum PizarraActionTypes {
	PizarraLastEventosRequested = '[Pizarra Component] Pizarra Last Eventos Requested',
	PizarraLastEventosLoaded = '[Pizarra API] Pizarra Last Eventos Loaded',
	PizarraCancelled = '[Pizarra API] Pizarra Cancelled',
	PizarraRight = '[Pizarra API] Pizarra Right'
};

export class PizarraLastEventosRequested implements Action {
	readonly type: string = PizarraActionTypes.PizarraLastEventosRequested;
	constructor() {};
};

export class PizarraLastEventosLoaded implements Action {
	readonly type: string = PizarraActionTypes.PizarraLastEventosLoaded;
	constructor( public payload: { status: ContenidoStatus, eventos: PizarraEvento[] } ) {};
};

export class PizarraCancelled implements Action {
	readonly type: string = PizarraActionTypes.PizarraCancelled;
	constructor( public payload: { status: ContenidoStatus } ) {};
};

export class PizarraRight implements Action {
	readonly type: string = PizarraActionTypes.PizarraRight;
	constructor() {};
};

export type PizarraActions = PizarraLastEventosRequested | PizarraLastEventosLoaded | PizarraCancelled | PizarraRight;